import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { getRoleHome, useAuth } from "../auth/AuthContext";
import { ARAGON_COLORS } from "../theme/AragonTheme";

function ProtectedRoute({ roles, children }) {
  const location = useLocation();
  const { status, user } = useAuth();
  if (status === "loading") {
    return (
      <Box
        sx={{
          minHeight: "100dvh",
          display: "grid",
          placeItems: "center",
          bgcolor: ARAGON_COLORS.ivory,
          color: ARAGON_COLORS.navy,
        }}
      >
        <Box sx={{ textAlign: "center" }}>
          <CircularProgress size={28} sx={{ color: ARAGON_COLORS.navy }} />
          <Typography sx={{ mt: 1.5, fontSize: 13 }}>Checking your secure session…</Typography>
        </Box>
      </Box>
    );
  }
  if (status !== "authenticated" || !user) {
    return <Navigate to="/auth/login" replace state={{ from: location }} />;
  }
  const normalizedRole = String(user.role || "").toLowerCase();
  if (roles?.length && !roles.includes(normalizedRole)) {
    return <Navigate to={getRoleHome(normalizedRole)} replace />;
  }
  return children || <Outlet />;
}

export default ProtectedRoute;
